import {Component, OnDestroy, OnInit} from '@angular/core';
import {InteractionDocumentDto, UserInteractionDto, UserInteractionTypeDto} from "../../types/ds-interaction.types";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {Subscription} from "rxjs";
import {InteractionEvent, InteractionService, InteractionSubjectData} from "../../service/interaction.service";
import {FormControlStatus} from "@angular/forms";
import {UploadDocumentType} from "../../../core/component/core-upload/core-upload.component";
import {ActivatedRoute, Router} from "@angular/router";
import {InteractionApiService} from "../../api/interaction-api.service";
import {InteractionStepComponent} from "../interaction-step/interaction-step.component";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {ConfirmationService} from "primeng/api";


@Component({
  selector: 'app-interaction-form',
  templateUrl: './interaction-form.component.html',
  styleUrls: ['interaction-form.component.scss']
})
export class InteractionFormComponent extends InteractionStepComponent implements OnInit, OnDestroy {

  currentFormGroupStatus?: FormControlStatus;
  currentValue?: any;
  isFileSelected = false;
  visible = false;
  selectedDocument: InteractionDocumentDto | undefined;


  constructor(
    protected confirmationService: ConfirmationService,
    protected interactionApiService: InteractionApiService,
    override interactionService: InteractionService,
    override messageService: AppMessageService,
    protected route: ActivatedRoute,
    protected router: Router) {
    super(interactionService, messageService);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }

  override handleEvent(event: InteractionEvent) {
    super.handleEvent(event);

    if (event == "next" || event == "finalize") {

      if (this.currentFormGroupStatus != "VALID") {
        this.messageService.showErrorMessage("", "Du musst noch ein paar Pflichteingaben ausfüllen!");
      } else {
        this.interactionService.saveForm(this.currentValue, true);
      }

    } else if (event == "previous") {
      // previous step not supported
    }

  }


  handleFormGroupStatusChange(formStatus: FormControlStatus) {
    this.currentFormGroupStatus = formStatus;
  }

  handleFormGroupValueChange(value: any) {
    this.currentValue = value;
  }

  handleFileSelect(event: File) {
    this.isFileSelected = true;
  }

  handleFileClear() {
    this.isFileSelected = false;
  }

  handleFileUpload(files: UploadDocumentType[]) {
    this.interactionService.uploadDocuments(files, this.currentValue);
  }

  onShowDocument(doc: InteractionDocumentDto) {

    if (doc.id) {
      this.visible = true;
      this.selectedDocument = doc;
    }
  }

  onDeleteDocument(event: MouseEvent, documentId: number) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Bist du dir sicher?',
      header: 'Bestätigung',
      icon: 'pi pi-exclamation-triangle text-red-600',
      acceptIcon: "none",
      rejectIcon: "none",
      acceptLabel:'Ja',
      rejectLabel:'Nein',
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.interactionService.deleteDocument(documentId);
      },
      reject: () => {
        this.messageService.showErrorMessage('Abgelehnt', 'Ihre Anfrage wurde abgelehnt.');
      }
    });

  }


  handleWindowOpened(event: boolean) {
    this.visible = false;
  }


}
